namespace MACRAIL {

export enum ConfirmAlertState {
    NotApplicable = 'notapplicable',
    Unconfirmed = 'unconfirmed',
    Confirmed = 'confirmed',
}


/**
 * Create and show a modal dialog easily.
 */
export class ConfirmAlert {

    private element: JQuery;

    private contentElement: JQuery;

    private confirmButton: JQuery;

    private state: ConfirmAlertState;

    private oldContent: string;

    /**
     * Create a new ConfirmAlert
     *
     * @param element The alert div.
     */
    public constructor(element: JQuery | string) {
        this.element = $(element);

        this.contentElement = this.element.find('.alert-content');
        this.confirmButton = this.element.find('.alert-button');

        this.confirmButton.on('click', () => {
            this.setState(ConfirmAlertState.Confirmed);
        });
    }

    /**
     * Set the content as text only.
     *
     * @param text New text content.
     */
    public setText(text: string) {
        this.contentElement.text(text);
    }

    /**
     * Setthe content as HTML.
     *
     * @param html New HTML content.
     */
    public setHtml(html: string) {
        this.contentElement.html(html);
    }

    /**
     * Set the class for this alert.
     *
     * Valid values are the bootstrap 'status' classes - info, warning, etc.
     *
     * @param className New class.
     */
    public setClass(className: string) {
        this.element.setAlertClass(className);
    }

    public getState() {
        return this.state;
    }

    public setState(state: ConfirmAlertState) {

        // If the state isn't changing, stop.
        if (this.state === state) {
            return;
        }

        this.state = state;

        this.element.removeClass('state-notapplicable state-unconfirmed state-confirmed');
        this.element.addClass('state-' + state);

        this.element.trigger('confirmalert-statechange');
    }
}

}
